module.exports = __webpack_public_path__ + "img/icon-differentials_05.3eef4fb1.svg";